import styled from "styled-components";

export const ColorPaletteContainer = styled.div`
  position: relative;
  z-index: 20;
`;

export const ColorPalettesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: absolute;
  top: 100%;
  right: 0;
  width: 320px;
  box-shadow: 0px 4px 12px 0px rgba(0, 41, 111, 0.25);
  background-color: ${({ theme }) => theme.bg.secondary};
  border-radius: 20px;
  margin-top: 4px;
  padding: 16px;
`;

export const ColorPalettesButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border: none;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.bg.primary};
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
  transition: background-color 0.1s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.15);
  }
`;

export const ColorPalettesHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ColorPalettesHeading = styled.h1`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.title};
  font-family: "PP Formula";
`;

export const ColorPalettesParagraph = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.text.text};
`;

export const ColorPalettesColorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ColorPaletteColorsCollapsibleContainer = styled.details`
  display: flex;
  flex-direction: column;

  &[open] > {
    gap: 8px;

    summary::after {
      transform: rotate(0deg);
    }
  }

  & > div:not(:first-child) {
    margin-top: 8px;
  }
`;

export const ColorPalettesColorsCollapsibleHeading = styled.summary`
  position: relative;
  color: ${({ theme }) => theme.text.title};
  list-style: none;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 500;
  font-family: "PP Formula";
  user-select: none;

  &::after {
    content: "";
    position: absolute;
    background-image: url("/img/drawers/settings-icons/caret-up.svg");
    height: 20px;
    width: 20px;
    top: -5px;
    margin-left: 8px;
    transform: rotate(180deg);
    cursor: pointer;
  }

  &::-webkit-details-marker {
    display: none;
  }
`;

export const ColorPalettesColorsHeading = styled.h1`
  margin: 0;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 500;
  user-select: none;
  font-family: "PP Formula";
`;

export const ColorPalettesColors = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
`;

export const ColorPalettesColorTile = styled.div`
  position: relative;
  display: grid;
  place-content: center;
  width: ${({ size = 40 }) => size}px;
  height: ${({ size = 40 }) => size}px;
  cursor: pointer;
  border-radius: 9999px;
  color: ${({ textColor }) => textColor};
  background: ${({ accentColor }) => accentColor};
  user-select: none;

  ${({ isSelected = false, hasHover = true }) => {
    if (isSelected) {
      return `
      outline-offset: 2px;
      outline: 4px solid rgba(0, 175, 255, 0.3);
    `;
    }

    if (hasHover) {
      return `
      &:hover {
        outline: 4px solid rgba(0, 175, 255, 0.3);
      }
    `;
    }
  }}
`;

export const ColorPalettesCheckContainer = styled.div`
  position: absolute;
  line-height: 0;
  bottom: -5px;
  right: -5px;
`;
